import axios from 'axios'
import AuthToken from '@/auth/auth-token'

class Images {
  constructor () {
    const base = axios.create({
      // using base items api
      baseURL: process.env.VUE_APP_BASE_API,
      withCredentials: false,
      headers: {
        'Content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
      }
    })
    this.images = base
  }

  async get (upc, params = {}) {
    if (process.env.NODE_ENV === 'production') { // TO DO: remove when dev has jbg tenant images
      params.tenant = 'jbg'
    }
    await AuthToken.setAuth(this.images)
    return this.images({
      url: `/image/${upc}`,
      method: 'GET',
      params: { include_metadata: false, ...params }
    })
  }
}

export default new Images()